import { Box } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";

export default function StepResult({ success }) {
  const isSuccess = Boolean(success);

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: 88,
          height: 88,
          borderRadius: "9999px",
          backgroundColor: "transparent",
          border: "1px solid",
          borderColor: isSuccess ? "success.light" : "error.light",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {isSuccess ? (
          <CheckCircleOutlineIcon sx={{ fontSize: 48, color: "success.main" }} />
        ) : (
          <HighlightOffOutlinedIcon sx={{ fontSize: 48, color: "error.main" }} />
        )}
      </Box>
    </Box>
  );
}
